// Copyright (c) 2017 Comsearch, Inc., All rights reserved

import React from 'react'
import { bool, object, string } from 'prop-types'
import { connect } from 'react-redux'
import { Field } from 'redux-form'
import { SelectFromSet } from 'components/Form'

class AntennaCompliances extends React.Component {
  static propTypes = {
    antennaCompliances: object.isRequired,
    applicationName: string.isRequired,
    complianceName: string.isRequired,
    disabled: bool,
    id: string,
    selectedApplication: string.isRequired,
    sourceForm: string.isRequired,
  }

  state = {
    options: [],
  }

  componentWillMount () {
    this.updateComplianceOptions()
  }

  componentDidUpdate (op) {
    // if the application was changed.
    // change the options for compliance
    // based on the new application.
    if (this.props.selectedApplication !== op.selectedApplication) {
      this.updateComplianceOptions()
    }
  }

  updateComplianceOptions = () => {
    const {
      antennaCompliances,
      selectedApplication,
    } = this.props

    const options = antennaCompliances.reduce((a, d, i) => {
      const antennaApplicationId = d.getIn(['antennaApplication', 'antennaApplicationId'])
      if (antennaApplicationId === +selectedApplication) {
        a.push({
          label: d.get('compliance'),
          value: d.get('complianceId'),
        })
      }
      return a
    }, [])

    this.setState(() => ({ options }))
  }

  render () {
    const {
      disabled,
      id,
      complianceName,
    } = this.props

    return (
      <Field
        component={SelectFromSet}
        disabled={disabled}
        emptyOptionLabel={`Select Compliance`}
        id={`${id}-antenna-compliance`}
        selectLabel={`FCC Compliance`}
        name={complianceName}
        options={this.state.options}
        valueKey={'value'} />
    )
  }
}

const mapStateToProps = ({ domain, form }, { applicationName, sourceForm }) => {
  const antennaCompliances = domain.get('antennaCompliances')
  // the currently selected application for the given form.
  const selectedApplication = form[sourceForm].values[applicationName]

  return {
    antennaCompliances,
    selectedApplication,
  }
}

export default connect(
  mapStateToProps,
)(AntennaCompliances)
